import api from './api';
import { authService } from './api';

const surveyService = {
  // =====================================================
  // Gerenciamento de Template de Perguntas
  // =====================================================

  getSurveyTemplates: async () => {
    const selectedHotel = authService.getSelectedHotel();
    const params = selectedHotel ? { hotelId: selectedHotel.id } : {};
    const response = await api.get('/surveys/templates', { params });
    return response.data;
  },

  createSurveyTemplate: async (data) => {
    const selectedHotel = authService.getSelectedHotel();
    const params = selectedHotel ? { hotelId: selectedHotel.id } : {};
    const response = await api.post('/surveys/templates', data, { params });
    return response.data;
  },

  updateSurveyTemplate: async (id, data) => {
    const response = await api.put(`/surveys/templates/${id}`, data);
    return response.data;
  },

  deleteSurveyTemplate: async (id) => {
    const response = await api.delete(`/surveys/templates/${id}`);
    return response.data;
  },

  // =====================================================
  // Gerenciamento de Convites
  // =====================================================

  generateSurveyInvitation: async (reservationId) => {
    const response = await api.post('/surveys/generate-invitation', { reservationId });
    return response.data;
  },

  getSurveyInvitation: async (token) => {
    const response = await api.get(`/surveys/public/invitation/${token}`);
    return response.data;
  },

  // =====================================================
  // Submissão de Avaliação (Público)
  // =====================================================

  submitSurveyResponse: async (token, data) => {
    const response = await api.post(`/surveys/public/submit/${token}`, data);
    return response.data;
  },

  // =====================================================
  // Visualização de Avaliações (Admin)
  // =====================================================

  getHotelSurveys: async () => {
    const selectedHotel = authService.getSelectedHotel();
    const params = selectedHotel ? { hotelId: selectedHotel.id } : {};
    const response = await api.get('/surveys/surveys', { params });
    return response.data;
  },

  getSurveyDetails: async (id) => {
    const response = await api.get(`/surveys/surveys/${id}`);
    return response.data;
  },

  getSurveyStats: async () => {
    const selectedHotel = authService.getSelectedHotel();
    const params = selectedHotel ? { hotelId: selectedHotel.id } : {};
    const response = await api.get('/surveys/stats', { params });
    return response.data;
  }
};

export default surveyService;

